import vue from 'vue'
import App from './App'
import router from './router'

vue.config.productionTip = false

window.router = router


if(process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') {
  let vConsole = require('vconsole');
  new vConsole();
}
vue.config.performance = true;


/* eslint-disable no-new */
new vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js